import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function CookiePolicy() {
    return (
        <div className="min-h-screen bg-ink grain pt-24 pb-16 px-6 md:px-10" data-testid="cookie-policy-page">
            <div className="max-w-3xl mx-auto">
                <Link to="/" className="inline-flex items-center gap-2 text-gold hover:text-gold-light text-xs tracking-widest uppercase mb-6">
                    <ArrowLeft size={14} /> Torna alla home
                </Link>
                <div className="text-gold text-xs tracking-[0.4em] uppercase">Documento legale</div>
                <h1 className="font-serif text-4xl md:text-5xl text-white mt-2 mb-2">Cookie Policy</h1>
                <p className="text-gray-500 text-xs">Ultimo aggiornamento: 24 aprile 2026</p>

                <div className="mt-10 space-y-6 text-gray-300 text-sm leading-relaxed">
                    <p>
                        Questo sito è gestito da <strong className="text-white">MAKAI di Maria Laura Pellino</strong> (P.IVA <span className="text-gold">09936410969</span>) e utilizza cookie e tecnologie simili per il corretto funzionamento e, previo consenso, per finalità statistiche aggregate. Di seguito l'elenco dei cookie utilizzati.
                    </p>

                    <h2 className="text-gold font-serif text-xl mt-6 font-light">Cookie tecnici (sempre attivi)</h2>
                    <Table rows={[
                        ["renova360_cookie_consent_v1", "Prenova by Renova360", "Memorizza la scelta sul banner cookie", "12 mesi"],
                        ["session_token (cookie HttpOnly)", "Prenova by Renova360", "Sessione di autenticazione utente/admin", "Sessione / 7 gg"],
                        ["__cf_bm, cf_clearance", "Cloudflare", "Sicurezza e mitigazione bot", "30 min / 24h"],
                    ]} />

                    <h2 className="text-gold font-serif text-xl mt-6 font-light">Cookie di profilazione (opt-in)</h2>
                    <p className="text-gray-400 text-xs italic">Attualmente non utilizziamo cookie di profilazione/marketing. Qualora venissero attivati in futuro, ti chiederemo nuovamente il consenso.</p>

                    <h2 className="text-gold font-serif text-xl mt-6 font-light">Servizi di terze parti</h2>
                    <ul className="list-disc pl-5 space-y-1.5">
                        <li><strong className="text-white">Stripe</strong> — solo nelle pagine di checkout, per la prevenzione frodi (cookie tecnici).</li>
                        <li><strong className="text-white">Cloudflare</strong> — CDN e protezione, cookie tecnici di sicurezza.</li>
                    </ul>

                    <h2 className="text-gold font-serif text-xl mt-6 font-light">Come gestire i cookie</h2>
                    <p>
                        Puoi cambiare le tue scelte cancellando il cookie <code className="text-gold">renova360_cookie_consent_v1</code> dal tuo browser: il banner riapparirà al prossimo accesso. Puoi anche disabilitare tutti i cookie dalle impostazioni del browser, ma alcune funzionalità del sito potrebbero non essere più disponibili.
                    </p>

                    <p className="mt-4 text-xs text-gray-500">
                        Per maggiori informazioni consulta l'<Link className="text-gold underline" to="/privacy">Informativa sulla privacy</Link>.
                    </p>
                </div>
            </div>
        </div>
    );
}

function Table({ rows }) {
    return (
        <div className="overflow-x-auto border border-white/10 rounded-sm mt-3">
            <table className="w-full text-xs">
                <thead className="bg-white/5">
                    <tr className="text-[10px] uppercase tracking-widest text-gold">
                        <th className="text-left px-4 py-2.5">Nome</th>
                        <th className="text-left px-4 py-2.5">Provider</th>
                        <th className="text-left px-4 py-2.5">Funzione</th>
                        <th className="text-left px-4 py-2.5">Durata</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((r, i) => (
                        <tr key={i} className="border-t border-white/5">
                            {r.map((c, j) => (
                                <td key={j} className="px-4 py-2.5 text-gray-300">{j === 0 ? <code className="text-gold">{c}</code> : c}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
